/* tslint:disable:max-classes-per-file */

class CaCollectionFieldAliases {
    public KARYOTYPE: string = "Karyotype";
}
class HlaCollectionFieldAliases {
    public IHW_NUMBER: string = "IHWNumber";
}

export class FieldAliases {
    public static CA_COLLECTION: CaCollectionFieldAliases = new CaCollectionFieldAliases();
    public static HLA_COLLECTION: HlaCollectionFieldAliases = new HlaCollectionFieldAliases();
}
